import { useState, useEffect } from 'react';
import { onSnapshot, query, collection } from 'firebase/firestore';
import { db, addConflit, updateConflit, deleteConflit } from '../config/firebase';

export const useConflits = () => {
  const [conflits, setConflits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Écouter les changements en temps réel
    const q = query(collection(db, 'conflits'));
    
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setConflits(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Erreur Firestore:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    // Nettoyer l'écouteur quand le composant se démonte
    return () => unsubscribe();
  }, []);

  const createConflit = async (data) => {
    try {
      await addConflit(data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const editConflit = async (id, data) => {
    try {
      await updateConflit(id, data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const removeConflit = async (id) => {
    try {
      await deleteConflit(id);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  return {
    conflits,
    loading,
    error,
    createConflit,
    editConflit,
    removeConflit
  };
};
